export default __webpack_public_path__ + "static/media/pixel-m2.25c985f5.jpg";